import { isUndefined, omitBy } from 'lodash/fp';

export const omitUndefined = omitBy(isUndefined);
